import React from 'react';
export function SolutionSection() {
  return <section className="bg-gradient-to-br from-[#1a0533] via-[#2d1052] to-[#3b1466] py-24 px-4 relative overflow-hidden" data-id="element-202">
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#FFD700] opacity-5 blur-[150px] rounded-full pointer-events-none" data-id="element-203"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-204">
        <h2 className="text-5xl md:text-6xl font-black text-[#FFD700] mb-8 drop-shadow-lg" data-id="element-205">
          💡 La solución
        </h2>

        <p className="text-2xl text-[#c4b5d4] mb-8" data-id="element-206">Por eso creamos:</p>

        <div className="bg-black/40 border border-[#a855f7]/50 rounded-3xl p-10 md:p-16 shadow-2xl" data-id="element-207">
          <h3 className="text-4xl md:text-5xl font-bold text-white mb-8" data-id="element-208">
            🎓 Dominá la Inteligencia Artificial
          </h3>

          <p className="text-xl md:text-2xl text-white leading-relaxed mb-8" data-id="element-209">
            Un entrenamiento práctico donde vas a aprender cómo usar
            herramientas de IA reales paso a paso.
          </p>

          <p className="text-2xl md:text-3xl text-[#FFD700] font-bold" data-id="element-210">
            Sin tecnicismos. Sin teoría innecesaria. Directo a lo que funciona.
          </p>
        </div>
      </div>
    </section>;
}